///
/// EarthBrowser
///
/// Created by Matt Giger on 11/29/2025
/// Copyright (c) 2025 Geodata Labs
///

import { type SubscriptionIdentifier } from "./subscription"

export interface PricingPlan {
	name: string
	link: string
	priceId: string
	price: number
	currency: string
	interval: string
	entitlements: string[]
}

export const PricingPlans: Record<SubscriptionIdentifier, PricingPlan> = {
	"ad_supported": {
		name: "Free",
		link: "",
		priceId: "",
		price: 0,
		currency: "usd",
		interval: "year",
		entitlements: [
			"All live layers and deep links",
			"3-day forecasts",
			"2-hour radar loop",
			"2 devices",
		],
	},

	"free_trial": {
		name: "Free Trial",
		link: "",
		priceId: "",
		price: 0,
		currency: "usd",
		interval: "year",
		entitlements: [],
	},

	"beta": {
		name: "Beta",
		link: "",
		priceId: "",
		price: 0,
		currency: "usd",
		interval: "year",
		entitlements: [],
	},

	"beta_yearly": {
		name: "Beta Yearly",
		link: "",
		priceId: "",
		price: 0,
		currency: "usd",
		interval: "year",
		entitlements: [],
	},

	"yearly": {
		name: "EarthBrowser Yearly",
		// Internal route that starts the Stripe checkout flow (SubscribeComponent
		// calls create-checkout-session). PricingCard navigates here via the router.
		link: "/subscribe",
		// LIVE-mode Stripe recurring Price for the $39.99/yr plan (product
		// prod_VSti9WVcAyi1RG; profile_product row via admin migration 038).
		// Test-mode environments override it with STRIPE_YEARLY_PRICE_ID in
		// .dev.vars (test price price_1UDDBSF9vOwKpRyZgyrXX3qg, row from
		// migration 017). See documentation/monetization/STRIPE_SETUP.md.
		priceId: "price_1URxvVF9vOwKpRyZRbXkJZRT",
		price: 39.99,
		currency: "usd",
		interval: "year",
		entitlements: [
			"Extended forecasts \u2014 up to 10 days",
			"48-hour radar time machine",
			"5 devices",
			"No support prompts",
		],
	},
}

